import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {
  SURVEY_COMPLETE_CLAIM_NOW,
  SURVEY_COMPLETE_HOME,
  SURVEY_COMPLETE_REMIND_LATER,
  SURVEY_COMPLETE_START_EKYC,
  WEB_SURVEY_COMPLETE_SIGN_UP,
  WEB_SURVEY_COMPLETE_VERIFY_MOBILE,
} from '../../lib/survey-completion-messages'
import {
  surveyCompletionActionsRowNoRewardSx,
  surveyCompletionActionsRowSx,
  surveyCompletionClaimButtonSx,
  surveyCompletionHomeButtonSx,
  surveyCompletionHomeOnlyButtonSx,
} from '../../styles/surveyExecutionStyles'

interface SurveyCompletionActionsProps {
  readonly hasReward: boolean
  readonly signupSurveyMode: boolean
  /** When false (tenant KYC disabled), signup survey uses Claim Now / Home (BFP-1119). */
  readonly signupSurveyEkycGated?: boolean
  readonly webSurveySignupMode?: boolean
  readonly surveyFirstJourney?: boolean
  readonly onClaimNow: () => void
  readonly onHome: () => void
  readonly onStartEkyc?: () => void
  readonly onRemindLater?: () => void
  readonly onCreateAccount?: () => void
}

export function SurveyCompletionActions({
  hasReward,
  signupSurveyMode,
  signupSurveyEkycGated = true,
  webSurveySignupMode = false,
  surveyFirstJourney = false,
  onClaimNow,
  onHome,
  onStartEkyc,
  onRemindLater,
  onCreateAccount,
}: SurveyCompletionActionsProps) {
  if (webSurveySignupMode) {
    return (
      <Box
        sx={{ width: '100%', boxSizing: 'border-box' }}
        data-survey-completion-has-reward="true"
      >
        <Button
          variant="contained"
          onClick={onCreateAccount}
          sx={surveyCompletionClaimButtonSx}
          data-testid="survey-completion-create-account"
        >
          {surveyFirstJourney ? WEB_SURVEY_COMPLETE_VERIFY_MOBILE : WEB_SURVEY_COMPLETE_SIGN_UP}
        </Button>
      </Box>
    )
  }
  if (hasReward && signupSurveyMode && signupSurveyEkycGated) {
    return (
      <Box
        sx={surveyCompletionActionsRowSx}
        data-survey-completion-has-reward="true"
      >
        <Button
          variant="contained"
          onClick={onStartEkyc}
          sx={surveyCompletionClaimButtonSx}
          data-testid="survey-completion-start-ekyc"
        >
          {SURVEY_COMPLETE_START_EKYC}
        </Button>
        <Button
          variant="outlined"
          onClick={onRemindLater}
          sx={surveyCompletionHomeButtonSx}
          data-testid="survey-completion-remind-later"
        >
          {SURVEY_COMPLETE_REMIND_LATER}
        </Button>
      </Box>
    )
  }

  if (hasReward) {
    return (
      <Box
        sx={surveyCompletionActionsRowSx}
        data-survey-completion-has-reward="true"
      >
        <Button
          variant="contained"
          onClick={onClaimNow}
          sx={surveyCompletionClaimButtonSx}
          data-testid="survey-completion-claim-now"
        >
          {SURVEY_COMPLETE_CLAIM_NOW}
        </Button>
        <Button
          variant="outlined"
          onClick={onHome}
          sx={surveyCompletionHomeButtonSx}
          data-testid="survey-completion-home"
        >
          {SURVEY_COMPLETE_HOME}
        </Button>
      </Box>
    )
  }

  return (
    <Box
      sx={surveyCompletionActionsRowNoRewardSx}
      data-survey-completion-has-reward="false"
    >
      <Button
        variant="contained"
        onClick={onHome}
        sx={surveyCompletionHomeOnlyButtonSx}
        data-testid="survey-completion-home"
      >
        {SURVEY_COMPLETE_HOME}
      </Button>
    </Box>
  )
}
